export const breakpointSizes = {
  tablet: 768,
  desktop: 1024,
}

export const breakpoints: any = [`${breakpointSizes.tablet}px`, `${breakpointSizes.desktop}px`]

breakpoints.tablet = breakpoints[0]
breakpoints.desktop = breakpoints[1]
